
export default {
  props: {
    position: {
      type: String,
      default: 'start',
      validator(value) {
        return ['start', 'middle', 'end'].includes(value)
      },
    },
  },
}
